import { type User } from '@scoring/types';
import { useApiMutation } from '../../queries/useApiMutation';
import { produce } from 'immer';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { putBlob } from '../../queries';
import z from 'zod';

const UpdateImageResponseSchema = z.guid();

type UpdateImageResponse = z.infer<typeof UpdateImageResponseSchema>;

export const useUpdateUserImageMutation = () => {
    const mutation = useApiMutation<{ userId: string; image: FormData }, UpdateImageResponse>({
        mutationFn: async ({ userId, image }) =>
            putBlob(`users/${userId}/profile-picture`, image, UpdateImageResponseSchema),
        onManualCacheUpdate: (queryClient, response, args) =>
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    const index = draft.findIndex((ath) => ath.id === args.userId);
                    if (index !== -1) draft[index].profilePictureImageId = response;
                })
            ),
    });

    return mutation;
};
